
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-group-IIA-result",
      function () {
        return require("private-next-pages/tnpsc-group-IIA-result/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-group-IIA-result"])
      });
    }
  